import React, { createContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { userSelector } from '../../../store/session'
import { getEstimateFieldCategoryByProject } from '../../../services/estimate-field'

export const CategoriesContext = createContext()

export const CategoryProvider = ({ projectId, children }) => {
  const { user } = useSelector(userSelector)
  const [categories, setCategories] = useState([])

  const estimateIds = useMemo(
    () =>
      user?.projects
        ?.filter((project) => (projectId ? project.id == projectId : true))
        .filter((item) => !!item?.estimate?.id)
        .map((item) => item?.estimate?.id),
    [user, projectId]
  )

  useEffect(() => {
    getEstimateFieldCategoryByProject(estimateIds)
      .then((data) => {
        setCategories(data?.data?.map((item) => item.category))
      })
      .catch(() => {
        // TODO: error handling
        setCategories([])
      })
  }, [estimateIds])

  return <CategoriesContext.Provider value={[categories]}>{children}</CategoriesContext.Provider>
}
